import SendTickIcon from './SendTick'
import OpenedTickIcon from './OpenedTick'
import DialogIcon from './DialogLink'
import ArticleIcon from './ArticleLink'
import AnsweredIcon from './AnsweredIcon'
import UnansweredIcon from './UnansweredIcon'

export default {
    SendTickIcon,
    OpenedTickIcon,
    DialogIcon,
    ArticleIcon,
    AnsweredIcon,
    UnansweredIcon,
}